import { featureFlipping } from '@bedrock-rdk/config';
import {
  TOP_BAR_BACK,
  TOP_BAR_START_OVER,
  TOP_BAR_BACK_TO_LIVE,
  TOP_BAR_TRACKS,
  TOP_BAR_RELATED_VIDEOS,
  TOP_BAR_INFO_PAGE,
} from '../../logic/player/player.constants';
import { t } from '../i18n';
import { TOP_BAR_ITEMS } from './live.constants';

const defaultTopBarItems = [
  {
    id: TOP_BAR_ITEMS.BACK,
    icon: 'ArrowLeftWithBase',
    text: t('nav.backToNav'),
    action: TOP_BAR_BACK,
  },
  {
    id: TOP_BAR_ITEMS.START_OVER,
    icon: 'StartOver',
    text: t('player.replay'),
    action: TOP_BAR_START_OVER,
  },
  {
    id: TOP_BAR_ITEMS.BACK_TO_LIVE,
    icon: 'BackToLive',
    text: t('nav.backToLive'),
    action: TOP_BAR_BACK_TO_LIVE,
  },
  {
    id: TOP_BAR_ITEMS.TRACKS,
    icon: 'Tracks',
    text: t('nav.subtitles'),
    action: TOP_BAR_TRACKS,
  },
  {
    id: TOP_BAR_ITEMS.RELATED_VIDEOS,
    icon: 'RelatedVideos',
    text: t('nav.channelSelector'),
    action: TOP_BAR_RELATED_VIDEOS,
  },
  {
    id: TOP_BAR_ITEMS.INFO_PAGE,
    icon: 'Info',
    text: t('nav.synopsis'),
    action: TOP_BAR_INFO_PAGE,
  },
];

export const getTopBarItems = ({ isOnLive, hasTracks, hasRelatedVideos, hasProgramInformation, startOverFeature }) =>
  defaultTopBarItems.filter(({ id }) => {
    switch (id) {
      case TOP_BAR_ITEMS.START_OVER:
        return isOnLive && startOverFeature;
      case TOP_BAR_ITEMS.BACK_TO_LIVE:
        return !isOnLive && startOverFeature;
      case TOP_BAR_ITEMS.TRACKS:
        return hasTracks;
      case TOP_BAR_ITEMS.RELATED_VIDEOS:
        return !featureFlipping.player_liveHideRelatedChannels && hasRelatedVideos;
      case TOP_BAR_ITEMS.INFO_PAGE:
        return hasProgramInformation;
      default:
        return true;
    }
  });
